import React from "react";
import logo from "../../images/TestAssessify.png";
import toast, { LoaderIcon } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "react-query";
import { api } from "../../api";
import { Formik, Form, Field, ErrorMessage, FormikHelpers } from "formik";
import * as Yup from "yup";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { useCustomToast } from "../../components/customtoast/CustomToastProvider";
import { exams } from "../../api/exams";

export const strToLower = (str?: string): string => str?.toLowerCase() ?? "";

export function greetTime(): string {
  const hourOfDay = new Date().getHours();
  if (hourOfDay > 11 && hourOfDay <= 16) return "afternoon";
  if (hourOfDay > 16) return "evening";
  return "morning";
}

interface CheckProfileValues {
  email: string;
}

function CheckProfile(): JSX.Element {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const {pipeline_id, assessment_id}: any = useParams();
  const [profiles, setProfiles] = React.useState([]);
  const [showProfile, setShowProfile] = React.useState(false);
 const customToast: any = useCustomToast();

 const startSurvey = (data: any) => {
    const questionResponse = data?.data?.questions
        sessionStorage.setItem('survey-questions', JSON.stringify(questionResponse))
        sessionStorage.setItem('survey-user', 'employee')
        navigate('/candidate/survey')
  }

 const getQuestionsmutation = useMutation(exams.getExamQuestionsv2, {
        onSuccess: async (data: any) => {
          startSurvey(data)
        }})

  // adjust this to your actual API function name and type
  const { mutateAsync: onCheckProfile, isLoading: checkProfileLoading } = useMutation(api.checkProfile as (
    data: { email: string , pipeline_id: string, assessment_id: string }
  ) => Promise<any>);
  const {mutateAsync: onAuditLogin, isLoading: auditLoginLoading} = useMutation(api.auditLogin)

  const validationSchema = Yup.object({
    email: Yup.string().email(t("invalid-email")).required(t("email-required")),
  });

  const onSubmit = async (
    values: CheckProfileValues,
    { setSubmitting }: FormikHelpers<CheckProfileValues>
  ): Promise<void> => {
    setSubmitting(true);
    try {
      toast.loading(t("checking-profile"));
     const data = await onCheckProfile(
      {
      email: values.email,
      pipeline_id: pipeline_id,
      assessment_id: assessment_id
      }
     );
      toast.remove();
    //  toast.success(t("profile-found"));
      if(data?.data?.length) {
        setProfiles(data?.data);
        setShowProfile(true);
        return;
      }
      else customToast.error(`There is no profile existing for ${values.email}, please check your email and try again`);
      //sessionStorage.setItem("userProfile", JSON.stringify(data?.data));
     // navigate("/candidate/profile");
    } catch (error: any) {
      toast.remove();
      toast.error(error?.response?.data?.message || t("error-checking-profile"));
    } finally {
      setSubmitting(false);
    }
  };

  const handleProceed = async (profile: any) => {
    //navigate("/candidate/profile");
    try{
      toast.loading(t("logging-in"));
      const data = await onAuditLogin({
        user_exam_id: profile?.userExam?.id
      });
      toast.remove();
    //  toast.success('success');
      //navigate("/candidate/profile");
      sessionStorage.setItem("userToken", data?.data?.token);
      sessionStorage.setItem("user", JSON.stringify(data?.data?.user));
      if(data?.data?.assessment_data){
        let exam = data?.data?.assessment_data;
        if(exam?.completed_at){
          return customToast.success('You had already completed this assessment', 'Hello');
        }
         window.sessionStorage.setItem("assessment-type","survey");
            window.sessionStorage.setItem("active-assessment-id", exam?.user_exam_id);
            window.sessionStorage.setItem("active-assessment-user-id", exam?.user_id);
            window.sessionStorage.setItem("active-assessment", JSON.stringify(exam));
              getQuestionsmutation.mutate({
              userId:  data?.data?.user?.user_id || data?.data?.user?.id,
              examId: exam?.user_exam_id, 
              userExamId: exam?.user_id,
              showOnlyQuestions: true
            } as any);
      }
    } catch (error: any) {
      toast.remove(); 
      toast.error(error?.response?.data?.message || 'Unknown error');
    }
  };

  return (
    <div className={"bg-white p-4 lg:p-6"}>
      <div className={`w-full ${showProfile ? 'shadow-lg' : ''} flex justify-between pb-4 h-26 bg-inherit sticky top-0 cursor-pointer`}>
        <div className="h-full">
          <img
            src={logo}
            alt="Test Assessify"
            className="w-56 h-full object-contain"
          />
        </div>
      </div>

      {
        showProfile ?
          <section>
             <h1 className="flex justify-between mt-8 text-2xl font-medium mb-0"> Available User Profiles ({profiles?.length})
               <button className="text-lg font-normal bg-slate-100 rounded-lg py-3 px-4" onClick={ () => setShowProfile(false) }>Back</button>
             </h1>
             <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                  {profiles.map((profile: any) => (
                <div
                  key={profile?.id}
                  className="border rounded-lg py-8 p-4 shadow-lg flex flex-col"
                >
                  <div>
                    <p className="font-semibold text-darkBlue text-xl">
                      Name: {profile?.name}
                    </p>
                    <p className="text-gray-600 mt-2 font-medium text-lg mb-8">
                      Email: {profile?.email}
                    </p>
                  </div>
                  <button
                    onClick={() => handleProceed(profile)}
                    disabled={auditLoginLoading}
                    className="mt-4 text-center sm:mt-0 px-4 py-2 bg-[#88a848] text-white rounded-lg text-lg font-medium hover:bg-[#7b9a40] transition"
                  >
                    {
                      auditLoginLoading || getQuestionsmutation.isLoading ? (
                        <div className="w-full flex justify-center">  <LoaderIcon /> </div>
                      ) : 'Take Assessment'
                    }
                  </button>
                  
                </div> ))}
             </div>
          </section>
        :
      <div className="flex justify-center items-center mt-20 2xl:mt-0 2xl:h-screen">
        <div className="bg-cover bg-no-repeat bg-hero-img w-full md:w-[600px] lg:w-[900px] 2xl:w-[1440px] 2xl:h-[800px] rounded-xl p-2 lg:p-10 sm:shadow-2xl">
          <div className="my-2 shadow-2xl rounded-[8px] bg-white w-full lg:w-1/2 2xl:h-[600px] 2xl:mt-28 p-4 2xl:p-6">
            <div className="flex flex-col w-full">
              <div className="flex flex-col justify-center pb-8 lg:px-4 pt-8 my-auto md:justify-start md:pt-0 2xl:px-10">
                <Formik<CheckProfileValues>
                  initialValues={{ email: "" }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {() => (
                    <Form className="flex flex-col pt-3 md:pt-8">
                      <div className="2xl:mb-10">
                        <div className="flex md:items-center justify-start w-full overflow-hidden">
                          <h1 className="text-3xl md:w-3/4 object-contain font-medium text-darkBlue">
                            {t("good")} {t(greetTime())}
                          </h1>
                        </div>
                        <p className="my-2 text-baseFont text-slate-500">
                          Enter Your Email Address To Check Your Profile
                        </p>
                      </div>

                      <div className="flex flex-col pt-5">
                        <span className="text-md">{t("email-address")}</span>
                        <div className="flex relative mb-4 2xl:mb-10">
                          <span className="inline-flex rounded-l-lg items-center px-3 border-t bg-white border-l border-b border-gray-300 text-gray-500 shadow-sm text-sm">
                            <svg
                              width="15"
                              height="15"
                              fill="currentColor"
                              viewBox="0 0 1792 1792"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h2q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zm0-294q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z"></path>
                            </svg>
                          </span>
                          <Field
                            type="email"
                            id="email"
                            name="email"
                            className="flex-1 appearance-none rounded-r-lg border border-gray-300 w-full py-4 2xl:py-8 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-[#88a848] focus:border-transparent"
                            placeholder="Enter your email"
                          />
                        </div>
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-red-500 text-sm"
                        />
                      </div>

                      <button
                        type="submit"
                        disabled={checkProfileLoading}
                        className="w-full mt-3 px-4 2xl:py-4 py-2 rounded-lg text-base font-semibold text-center text-white transition duration-200 ease-in bg-[#88a848] shadow-md focus:outline-none focus:ring-2"
                      >
                        {
                          checkProfileLoading ? (
                            <div className="w-full flex justify-center"><LoaderIcon /></div>
                          ) : 
                          <span className="w-full text-xl 2xl:text-2xl">
                          Check Profile
                        </span>
                        }
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
}

export default CheckProfile;
